import React, {useState} from 'react';

import {CloneDocumentModal} from 'app/components/general/GenericDocumentActionButtons/CloneDocumentModal';
import {DeleteDocumentModal} from 'app/general/modals/DeleteDocumentModal';
import {ActionsButton} from 'app/general/widgets/ActionsButton';
import {gt} from 'app/utils/i18n';

import type {KnowledgebaseSerializedType} from 'sweet-types';

type Props = {
  kb: KnowledgebaseSerializedType;
};

export function KBEditPageActionsButton({kb}: Props) {
  const [showingDeleteModal, showDeleteModal] = useState<boolean>(false);
  const [showingDuplicateModal, showDuplicateModal] = useState<boolean>(false);

  return (
    <>
      <ActionsButton
        actions={[
          {
            key: 'duplicate',
            icon: 'far fa-copy',
            text: gt('Duplicate'),
            callback: () => showDuplicateModal(true),
          },
          {
            key: 'delete',
            icon: 'far fa-trash',
            text: gt('Delete'),
            callback: () => showDeleteModal(true),
          },
        ]}
      >
        <button className="btn btn-sm btn-light procedure-actions-tour">
          <i className="fa fa-fw fa-bolt" />
          <span className="d-none d-lg-inline"> {gt('Actions')}</span>
        </button>
      </ActionsButton>
      <DeleteDocumentModal
        show={showingDeleteModal}
        object={{
          url: kb.url,
          name: kb.name,
          content_type: 'knowledgebase',
        }}
        redirectContentType={'knowledgebase'}
        onClose={() => showDeleteModal(false)}
      />
      <CloneDocumentModal
        contentType={'knowledgebase'}
        documentTitle={kb.name}
        documentURL={kb.url}
        isOpen={showingDuplicateModal}
        showFolder={false}
        showTeam={false}
        onClone={() => Promise.resolve()}
        onClose={() => showDuplicateModal(false)}
      />
    </>
  );
}
